import { getBase64Type } from '../../util';
import { $axios } from './config';
import { Buffer } from 'buffer';

const url = '/User';

const getUsers = async (type = '') => {
    return $axios.get(`${url}/getUsers?userType=${type || ''}`);
};

const getADDetailsByUsername = async (username) => {
    return $axios.get(`${url}/getADDetailsByUsername?adUsername=${username}`);
};

const getRoles = async () => {
    return $axios.get(`${url}/getRoles`);
};

const getRolesAndPermissions = async () => {
    return $axios.get(`${url}/getRolesAndPermissions`);
};

const getAllPermissions = async () => {
    return $axios.get(`${url}/getAllPermissions`);
};

const addPermissionsToRole = async (payload) => {
    return $axios.post(`${url}/addPermissionsToRole`, payload);
};

const matchPermissionsToRole = async (payload) => {
    return $axios.post(`${url}/MatchPermissionsToRole`, payload);
};

const addRole = async (payload) => {
    return $axios.post(`${url}/addRole`, payload);
};

const removeRole = async (payload) => {
    return $axios.post(`${url}/removeRole`, payload);
};

const getFaqs = async () => {
    return $axios.get(`/FAQ/getAllFAQs`);
};

const addFaq = async (payload) => {
    return $axios.post(`/FAQ/addOrUpdateFAQ`, payload);
};

const deleteFaq = async (faqId) => {
    return $axios.post(`/FAQ/deleteFAQ?id=${faqId}`);
};

const getLoggedInUserDetails = async () => {
    return $axios.get(`${url}/getLoggedInUserDetails`);
};

const createUser = async (payload) => {
    return $axios.post(`${url}/addUser`, payload);
};

const createExternalUser = async (payload) => {
    return $axios.post(`${url}/createExternalUser`, payload);
};

const editUser = async (payload) => {
    return $axios.post(`${url}/editUser`, payload);
};

const deactivateUser = async (payload) => {
    return $axios.post(`${url}/deactivateUser`, payload);
};

const activateUser = async (payload) => {
    return $axios.post(`${url}/activateUser`, payload);
};

const getUserById = async (userId) => {
    return $axios.get(`${url}/getUserById?userId=${userId}`);
};

const getUserRoles = async (userId) => {
    return $axios.get(`${url}/getUserRoles?userId=${userId}`);
};

const getUsersInRole = async (roleId) => {
    return $axios.get(`${url}/getUsersInRole?roleId=${roleId}`);
};

const assignUserRole = async (payload) => {
    return $axios.post(`${url}/assignUserRole`, payload);
};

const removeUserRole = async (payload) => {
    return $axios.post(`${url}/removeUserRole`, payload);
};

const audits = async () => {
    return $axios.get(`/Admin/getAllAuditTrail`);
};

const getAllTeams = async () => {
    return $axios.get(`/Admin/getAllTeams`);
};

const getAllHelpItems = async () => {
    return $axios.get(`/admin/getAllHelpItems`);
};

const getHelpFileById = async (id, fileName, actualDocumentName) => {
    const resp = await $axios
        .get(`/admin/getHelpFileById?helpId=${id}`, {
            responseType: 'arraybuffer',
        })
        .then((response) => {
            const base64URL = Buffer.from(response, 'binary').toString('base64');

            var hiddenElement = document.createElement('a');
            const ext = String(actualDocumentName).split('.')[String(actualDocumentName).split('.').length - 1];
            hiddenElement.href = getBase64Type(actualDocumentName) + base64URL;
            hiddenElement.download = `${fileName}.${ext}`;
            hiddenElement.click();

            // openFileInNewBrowser(response, false);
            // printJS({ printable: base64URL, type: 'pdf', base64: true })
        })
        .catch((err) => {
            console.log(err);
            return '';
        });
};

// ---------------------- Team or Group ------------------------------

const addOrUpdateGroup = async (payload) => {
    return $axios.post(`/group/addOrUpdateGroup`, payload);
};

const deleteGroup = async (id) => {
    return $axios.post(`/group/deleteGroup?id=${id}`);
};

const addUserToGroup = async (payload) => {
    return $axios.post(`/group/addUserToGroup`, payload);
};

const getAllTeamsWithUsers = async () => {
    return $axios.get(`/group/getAllWithUsers`);
};

const removeUserFromGroup = async (payload) => {
    return $axios.post(`/group/removeUserFromGroup`, payload);
};

const addSubCategoryToTeam = async (payload) => {
    return $axios.post(`/complaintCategory/addSubCategoryToTeam`, payload);
};

const removeSubCategoryFromTeam = async (payload) => {
    return $axios.post(`/complaintCategory/removeSubCategoryFromTeam`, payload);
};

const getAllSubcategories = async () => {
    return $axios.get(`/complaintCategory/getAllSubcategories`);
};

const getAllCategories = async () => {
    return $axios.get(`/complaintCategory/getAllCategories`);
};

const getCategoryById = async (id) => {
    return $axios.get(`/complaintCategory/getCategoryById?id=${id}`);
};

const getSubcategoryByCode = async (id) => {
    return $axios.get(`/complaintCategory/getSubcategoryByCode?code=${id}`);
};

const deleteCategory = async (id) => {
    return $axios.post(`/complaintCategory/deleteCategory?id=${id}`);
};

const deleteSubcategory = async (id) => {
    return $axios.post(`/complaintCategory/deleteSubcategory?code=${id}`);
};

const saveSubcategory = async (payload) => {
    return $axios.post(`/complaintCategory/saveSubcategory`, payload);
};

const saveCategory = async (payload) => {
    return $axios.post(`/complaintCategory/saveCategory`, payload);
};

const getAllWithSubCategories = async () => {
    return $axios.get(`/group/getAllWithSubCategories`);
};

const matchUsersToGroup = async (payload) => {
    return $axios.post(`/group/matchUsersToGroup`, payload);
};

export {
    getUsers,
    getRoles,
    addRole,
    removeRole,
    removeUserRole,
    getLoggedInUserDetails,
    createUser,
    createExternalUser,
    editUser,
    deactivateUser,
    getUserById,
    getUserRoles,
    assignUserRole,
    matchPermissionsToRole,
    addFaq,
    deleteFaq,
    getFaqs,
    audits,
    getRolesAndPermissions,
    getAllPermissions,
    addPermissionsToRole,
    getUsersInRole,
    getAllTeams,
    getAllTeamsWithUsers,
    getADDetailsByUsername,
    getSubcategoryByCode,
    getCategoryById,
    getAllCategories,
    getAllSubcategories,
    addUserToGroup,
    removeUserFromGroup,
    matchUsersToGroup,
    getAllWithSubCategories,
    removeSubCategoryFromTeam,
    addSubCategoryToTeam,
    addOrUpdateGroup,
    deleteGroup,
    deleteCategory,
    deleteSubcategory,
    saveCategory,
    saveSubcategory,
    getAllHelpItems,
    getHelpFileById,
    activateUser,
};
